import { useAllowReschedulingMutation } from '../../Api/reservations';
import { formatDate, formatTime } from '../../Helpers/date-time-formatters';
import { fromLocalPhone } from '../../Helpers/phone-formatter';
import useTranslate from '../../Hooks/useTranslate';
import Button from '../../Style-guide/Button';
import Text from '../../Style-guide/Text';
import Title from '../../Style-guide/Title';

const ReservationsDisplay = ({ data }) => {
  const reservations = data ?? [];
  const tr = useTranslate();

  const { mutate: allowReschedulingRequest } = useAllowReschedulingMutation();

  const handleAllowRescheduling = (reservationId) => {
    allowReschedulingRequest({ params: { reservationId } });
  };

  const grouped = reservations.reduce((acc, item) => {
    const key = item.startTime.split('T')[0];
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);

    return acc;
  }, {});

  return (
    <section className='reservations-container'>
      <Title size='MD' className='reservations-title'>
        {tr('upcoming_reservations')}
      </Title>
      <div className='reservations-content-container'>
        {Object.entries(grouped).map(([date, items]) => {
          const formattedDate = formatDate(new Date(date));

          return (
            <div key={date} className='reservation-group'>
              <Text size='MD' className='reservation-date'>
                {formattedDate}
              </Text>

              {items.map((reservation) => {
                const {
                  id: reservationId,
                  allowRescheduling,
                  startTime,
                  endTime,
                  user,
                } = reservation;

                const formattedStartTime = formatTime(new Date(startTime));
                const formattedEndTime = formatTime(new Date(endTime));
                const isPassed = new Date(startTime) < new Date();

                return (
                  <div
                    key={`${reservation.startTime}-${reservation.endTime}`}
                    className='reservation-row'
                  >
                    <Text size='SM' className='reservation-time'>
                      {formattedStartTime} - {formattedEndTime}
                    </Text>
                    <div className='reservation-user'>
                      <Text size='SM'>
                        {user.firstName} {user.lastName}
                      </Text>
                      <Text size='SM'>(0{fromLocalPhone(user.phone)})</Text>
                    </div>

                    {allowRescheduling && (
                      <Text size='SM' className='rescheduling-allowed-text'>
                        {tr('rescheduling_allowed')}
                      </Text>
                    )}

                    {!allowRescheduling && !isPassed && (
                      <Button
                        className='allow-rescheduling-btn'
                        onClick={() => handleAllowRescheduling(reservationId)}
                      >
                        <Text size='SM' className='allow-rescheduling-btn-text'>
                          {tr('allow_rescheduling')}
                        </Text>
                      </Button>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ReservationsDisplay;
